export default {
    // 主要风格
    mainStyle: [
        {
            value: 1,
            name: '摇滚'
        },
        {
            value: 2,
            name: 'hiphop'
        },
        {
            value: 3,
            name: '民谣'
        },
        {
            value: 4,
            name: '流行'
        },
        {
            value: 5,
            name: '另类'
        },
        {
            value: 6,
            name: '海外'
        }
    ]
}